<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <label for="" class="vs-input--label">Component source</label>

        <v-select v-model="reader_data.component_source" :options="componentSourcesList" :kay="keySource"
          @input="(event) => changeComponentSource(event)" class="select_padding w-full" name="component_source"
          placeholder="Component source" :reduce="(source) => source.id" :selectable="(option) => !option.disabled"
          :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>
      <div class="vx-col w-full">
        <div class="flex ">

          <div class="vx-col w-1/2 mt-3 mr-8 port_mode">
            <label for class="vs-input--label">Port</label>
            <v-select v-model="portItem" :options="port_items" class="select_padding w-full pport" name="port"
              @input="(event) => changePortData(event)" placeholder="Port" :reduce="(port) => port.id"
              :selectable="(option) => !option.disabled" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col w-1/2 mt-3  port_mode">
            <label for class=" vs-input--label">Reader Type</label>

            <v-select v-model="reader_data.type" @input="(event) => changeTypeData(event)" :options="readerTypeList"
              class="select_padding w-full" name="type" placeholder="Reader Type" :reduce="(type) => type.id"
              :disabled="isDisabledReaderType" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <!-- <div class="vx-col w-1/2 mt-3  port_mode">
            <label for="" class="vs-input--label">Reader type</label>
            <v-select v-model="reader_data.readerType" :options="readerTypeList" class="select_padding w-full pport"
              name="readerType" placeholder="Reader Type" :dir="$vs.rtl ? 'rtl' : 'ltr'"
              :selectable="(option) => !option.disabled" />
          </div> -->
        </div>
        <div class="flex w-full">
          <div class="w-1/2 mr-8">
            <div class="vx-col mt-3 port_mode">
              <label for class="vs-input--label">Interface type</label>
              <v-select v-model="reader_data.wg_type" :options="interface_types" class="select_padding w-full"
                name="wg_type" placeholder="Interface type" :reduce="(type) => type.id"
                :disabled="isDisabledInterfaceType" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="vx-col mt-3">
              <label for="" class="vs-input--label">Direction</label>
              <v-select v-model="directionItem" :options="direction_options" class="select_padding w-full"
                name="direction" placeholder="Direction" :reduce="(dirs) => dirs.id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :selectable="(option) => !option.disabled" @input="(event) => changeDirectionItemData(event)" />
            </div>
          </div>

          <div class="w-1/2 mt-8 flex flex-col" v-if="reader_data.wg_type !== -1">
            <div class="vx-col ">
              <vs-checkbox v-model="reader_data.reverse_byte_order">Reverse byte order</vs-checkbox>
            </div>
            <div class="vx-col mt-4">
              <vs-checkbox v-model="reader_data.enable_crc">Enable CRC</vs-checkbox>
            </div>
            <div class="vx-col mt-4">
              <vs-checkbox v-model="reader_data.enable_buzzer">Enable buzzer
              </vs-checkbox>
            </div>
          </div>
        </div>
        <!-- <div v-if="!isFloor">
          <vs-input label="Name" class="mt-3 w-full" name="name" disabled v-model="reader_data.name"
            v-validate="'required'" />
        </div> -->


      </div>
    </div>

    <!-- <div class="w-full line"> </div>
    <div class="w-full flex ">
      <div class="vx-col w-1/2 mr-6 mt-3 port_mode">
        <label for="" class="vs-input--label">This Access Point Exits the Zone bellow </label>
        <v-select v-model="reader_data.exitsZone" :options="exitsZoneOptions" class="select_padding w-full mode"
          name="status" placeholder="Exits the Zone" :reduce="(mode) => mode.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>
      <div class="vx-col w-1/2 mt-3 port_mode">
        <label for="" class="vs-input--label">This Access Point Enters the Zone bellow</label>
        <v-select v-model="reader_data.exitsEnter" :options="exitsEntersOptions" class="select_padding w-full mode"
          name="status" placeholder="Enters the Zone" :reduce="(mode) => mode.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>
    </div> -->




    <!-- <div class="vx-row">


      <div class="vx-col w-1/3 mt-3 port_mode">
        <label for="" class="vs-input--label">Mode</label>
        <v-select v-model="reader_data.mode" disabled :options="reader_modes" class="select_padding w-full mode"
          name="status" placeholder="Mode" :reduce="(mode) => mode.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>


    </div> -->



    <div class="vx-row mt-3" v-if="reader_data.wg_type == -1">
      <div class="vx-col w-1/2">
        <label for="" class="vs-input--label">Baud rate</label>
        <v-select v-model="reader_data.baud_rate" :options="baud_rates" class="select_padding w-full" name="status"
          placeholder="Baud Rate" :reduce="(dirs) => dirs.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>

      <div class="vx-col w-1/2">
        <label for="" class="vs-input--label">Osdp address</label>
        <v-select v-model="reader_data.osdp_address" :options="osdp_addresses" class="select_padding w-full"
          name="status" placeholder="Osdp address" :reduce="(dirs) => dirs.id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
          :selectable="(option) => !option.disabled" />
      </div>
      <div class="vx-col w-1/2 mt-3">
        <label for="" class="vs-input--label">Card data format flags</label>
        <v-select v-model="reader_data.card_data_format_flags" :options="card_data_format_flags"
          class="select_padding w-full" name="status" placeholder="Card data format flags" :reduce="(dirs) => dirs.id"
          :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>

      <div class="vx-col w-1/2 mt-3">
        <label for="" class="vs-input--label">Keypad mode</label>
        <v-select v-model="reader_data.keypad_mode" :options="keypad_modes" class="select_padding w-full" name="status"
          placeholder="Card data format flags" :reduce="(dirs) => dirs.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>

      <div class="vx-col w-1/3 mt-3">
        <label for="" class="vs-input--label">Configuration</label>
        <v-select v-model="reader_data.configuration" :options="configurations" class="select_padding w-full"
          name="status" placeholder="Configuration" :reduce="(dirs) => dirs.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>
      <div class="vx-col w-1/3 mt-3">
        <label for="" class="vs-input--label">Led mode</label>
        <v-select v-model="reader_data.led_mode" :options="led_modes" class="select_padding w-full" name="status"
          placeholder="Configuration" :reduce="(dirs) => dirs.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>

      <div class="vx-col w-1/3 mt-3">
        <label for="" class="vs-input--label">Offline mode</label>
        <v-select v-model="reader_data.offline_mode" :options="offline_modes" class="select_padding w-full"
          name="status" placeholder="Configuration" :reduce="(dirs) => dirs.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>

      <div class="vx-col w-1/2 mt-5 flex_center">
        <vs-checkbox class="mt-3 custom__checkbox" v-model="reader_data.enable_osdp_secure_channel">Enable osdp secure
          channel</vs-checkbox>
      </div>
      <div class="vx-col w-1/2 mt-5 flex_center">
        <vs-checkbox class="mt-3 custom__checkbox" v-model="reader_data.enable_osdp_tracing">Enable osdp
          tracing</vs-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { zoneTree } from "@/functions/treeData";
import Treeselect from "@riophae/vue-treeselect";
import { checkPorts, checkDirPorts } from "@/functions/checkInputOutput";

export default {
  props: {
    expansion_boards: {
      type: Object,
      default: () => ({})
    },
    controllers_boards: {
      type: Object,
      default: () => ({})
    },
    selectedItem: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      keySource: 0,
      portItem: null,
      directionItem: null,
      isDisabledReaderType: false,
      isDisabledInterfaceType: false,
      readerTypeList: [
        { id: 0, label: "RFID", disabled: this.isFloor ? true : false },
        { id: 1, label: "Keypad", disabled: this.isFloor ? true : false },
        { id: 2, label: "RFID+KEYPAD", disabled: this.isFloor ? true : false },
      ],
      componentSourcesList: [{ id: 0, label: "ACU", disabled: this.isFloor ? true : false }],
      reader_data: {},
      zones: [],
      reader_type: {
        0: "RFID",
        1: "KEYPAD",
        2: "RFID_KEYPAD",
        3: "FINGERP",
        4: "FACE",
      },
      osdp_addresses: [],
      ports: [],
      direction_options: [
        { id: 0, label: "Entry" },
        { id: 1, label: "Exit" },
      ],
      port_items: [],
      groupObj: [],
    };
  },
  watch: {
    reader_data: {
      handler: function (reader_data, oldVal) {
        this.$store.commit("accessPoint/SET_EDIT_READER_DATA", {
          data: { ...reader_data },
        });
      },
      deep: true,
    },
    active_reader(data) {
      let access_point;
      let reader;
      if (this.isFloor) {
        this.reader_data = {
          ...this.$store.state.accessPoint.edit_acu_data.readers,
        };
        this.reader_data.name = this.reader_type[this.reader_data.type];
      } else {
        if (Number.isInteger(+this.active_point)) {
          access_point = this.access_points.find(
            (a) => a.id == +this.active_point
          );
          if (Number.isInteger(+data)) {
            reader = access_point.readers.find(
              (r) => r.id == +this.active_reader
            );
          } else if (
            access_point.new_readers &&
            access_point.new_readers[data]
          ) {
            reader = { ...access_point.new_readers[data] };
          } else {
            return;
          }
        } else {
          access_point =
            this.$store.state.accessPoint.edit_acu_data.new_access_points[
            this.active_point
            ];
          reader = { ...access_point.readers[data] };
        }

        if (!reader.data) {
          this.reader_data = { ...reader, name: this.reader_type[reader.type] };
        } else if (reader.reader_info) {
          this.reader_data = {
            ...reader.reader_info,
            name: reader.reader_info.data.device,
          };
        } else if (reader.data && !reader.reader_info) {
          this.reader_data = {
            ...reader,
            name: reader.data.device,
          };
        }
      }

      this.setPorts();
      this.setDirectionPorts();
    },
  },
  methods: {
    changePortData(data) {
      this.portItem = data;
      this.reader_data = {
        ...this.reader_data,
        port: data
      };
      setTimeout(() => {
        this.port_items = this.definedPortOptionList(this.port_items, this.reader_data.component_source)
      }, 500);
    },
    changeTypeData(data) {
      this.reader_data.type = data;

      const componentSourceType = this.componentSourcesList.find(item => {
        return item.id === this.reader_data.component_source
      });
      console.log(componentSourceType.label, "componentSourceType.label");

      if (componentSourceType.ext_board === "GENERIC" || componentSourceType.label === "ACU") {
        if (data == 1) {
          this.isDisabledInterfaceType = false;
        } else {
          this.isDisabledInterfaceType = true;
          this.reader_data.wg_type = 0;
        }
      } else if (componentSourceType.ext_board === "AIR-R") {
        this.isDisabledInterfaceType = true;
        this.reader_data.wg_type = 0;
        this.isDisabledReaderType = true;
        this.reader_data.type = 0;
      }
    },
    changeDirectionItemData(data) {
      this.directionItem = data;
      this.reader_data = {
        ...this.reader_data,
        direction: data
      };
    },
    setDirectionPorts() {
      const data = this.$store.state.accessPoint.edit_acu_data;
      this.direction_options = [];

      const ports = checkDirPorts(data, this.active_point, this.active_reader);
      for (let i = 0; i < this.directions.length; i++) {
        if (ports.includes(this.directions[i].id)) {
          this.direction_options.push({
            ...this.directions[i],
            disabled: true,
          });
        } else {
          this.direction_options.push(this.directions[i]);
        }
      }
    },
    setPorts() {
      const data = this.$store.state.accessPoint.edit_acu_data;
      const ports = checkPorts(data, this.active_reader);
      this.ports = [];
      for (let i = 0; i < this.port_items.length; i++) {
        if (ports.includes(this.port_items[i].id)) {
          this.ports.push({ ...this.port_items[i], disabled: true });
        } else {
          this.ports.push(this.port_items[i]);
        }
      }
    },
    checkNumber(value, field) {
      return (this.reader_data[field] = +value.replace(/[^+0-9]/g, ""));
    },
    initValues() {
      this.zones = [];
      this.reader_data = {
        wg_type: 0,
        port: null,
        name: null,
        direction: null,
        mode: null,
        reverse_byte_order: false,
        enable_crc: false,
        enable_buzzer: false,
        baud_rate: null,
        card_data_format_flags: null,
        keypad_mode: null,
        configuration: null,
        led_mode: null,
        offline_mode: null,
        enable_osdp_secure_channel: false,
        enable_osdp_tracing: false,
        osdp_address: null,
      };

      this.$http
        .get(`accessPointZone`, {
          headers: { Authorization: localStorage.token },
        })
        .then((res) => {
          if (res.data.length) {
            this.groupObj = zoneTree(res.data);

            res.data.forEach((zone) => {
              this.zones.push({ id: zone.id, label: zone.name });
            });
          }
        });
    },

    changeComponentSource(selectedSource) {
      this.reader_data = {
        ...this.reader_data,
        component_source: selectedSource
      }
      const selectedItem = this.componentSourcesList.find(item => {
        return item.id === selectedSource
      })
      if (selectedItem.ext_board === "GENERIC" || selectedItem.label === "ACU") {
        if (this.reader_data.type == 1) {
          this.isDisabledInterfaceType = false;
        } else {
          this.isDisabledInterfaceType = true;
          this.reader_data.wg_type = 0;
        }
      } else if (selectedItem.ext_board === "AIR-R") {
        this.isDisabledInterfaceType = true;
        this.reader_data.wg_type = 0;
        this.isDisabledReaderType = true;
        this.reader_data.type = 0;
      } else {
        this.isDisabledInterfaceType = false;
        this.isDisabledReaderType = false;
      }

      if (!!selectedSource) {
        this.port_items = selectedItem.ext_board === "AIR-R" ? [
          { id: 1, label: "Internal" },
          { id: 2, label: "External" },
        ] : [
          { id: 1, label: "Internal" }
        ];
        this.ports = this.port_items;
        this.port_items = this.definedPortOptionList(this.port_items, selectedSource)

        this.reader_data.port = "1";
      } else if (this.editACUModel === "AIR-CR") {
        this.port_items = [
          { id: 1, label: "Internal" },
          { id: 2, label: "External" },
        ]
      } else {
        this.port_items = [
          { id: 1, label: "Wiegant port 1" },
          { id: 2, label: "Wiegant port 2" },
        ]
        this.setPorts();
      }
      setTimeout(() => {
        this.componentSourceList()
        this.keySource = this.keySource + 1;
      }, 700);

    },

    definedPortOptionList(portList, source = 0) {
      if (portList.length === 0) return [];
      const selectedPorts = this.selectedPortList;
      return portList.map(item => {
        return { ...item, disabled: selectedPorts.port ? !!selectedPorts.port[source] ? !!selectedPorts.port[source][`${item.id}`] : false : false }
      })
    },

    componentSourceList() {
      const extDevice = this.$store.state.accessPoint.ext_devicesList
      const GENERIC_flag = this.$store.state.accessPoint.isGENERIC_selected.selected;

      const ext_dev = [{ id: 0, label: "ACU", disabled: this.isFloor ? true : false }];
      for (let item of extDevice) {
        if (this.expansion_boards.reader_board[item.ext_board]) {
          if (this.expansion_boards.reader_board[item.ext_board].readers > 0) {
            ext_dev.push({
              ...item, id: item.id, label: item.label,
              disabled: item.label === "GENERIC" ? GENERIC_flag : false
            })
          }
        }
      }
      this.componentSourcesList = ext_dev;
    }
  },

  computed: {
    interface_types() {
      return this.$store.state.accessPoint.interface_types;
    },
    reader_modes() {
      return this.$store.state.accessPoint.reader_modes;
    },
    directions() {
      return this.$store.state.accessPoint.directions;
    },
    baud_rates() {
      return this.$store.state.accessPoint.baud_rates;
    },
    card_data_format_flags() {
      return this.$store.state.accessPoint.card_data_format_flags;
    },
    keypad_modes() {
      return this.$store.state.accessPoint.keypad_modes;
    },
    configurations() {
      return this.$store.state.accessPoint.configurations;
    },
    led_modes() {
      return this.$store.state.accessPoint.led_modes;
    },
    offline_modes() {
      return this.$store.state.accessPoint.offline_modes;
    },
    active_reader() {
      return this.$store.state.accessPoint.edit_active_reader;
    },
    active_point() {
      return this.$store.state.accessPoint.edit_active_point;
    },
    access_points() {
      return this.$store.state.accessPoint.edit_acu_data.access_points;
    },
    readers_types() {
      return this.$store.state.accessPoint.readers_types;
    },
    selectedPortList() {
      return this.$store.state.accessPoint.edit_acu_data.selectedPorts;
    },
    isGENERICSelected() {
      return this.$store.state.accessPoint.isGENERIC_selected.selected;
    },
    editACUModel() {
      return this.$store.state.accessPoint.edit_acu_data.model;
    },

    isFloor() {
      let model = this.$store.state.accessPoint.edit_acu_data.model;
      let elevator_mode =
        this.$store.state.accessPoint.edit_acu_data.elevator_mode;

      if ((model == "Icon" || model == "Icon-PRO") && elevator_mode) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {

    const dataReader = this.$store.state.accessPoint.edit_acu_data;
    this.$http
      .get(`accessPointZone`, {
        headers: { Authorization: localStorage.token },
      })
      .then((res) => {
        if (res.data.length) {
          this.groupObj = zoneTree(res.data);

          res.data.forEach((zone) => {
            this.zones.push({ id: zone.id, label: zone.name });
          });
        }
      });

    let address = [];
    for (let i = 1; i < 129; i++) {
      address.push({ id: i, label: i });
    }
    this.osdp_addresses = address;

    let access_point;
    let reader;

    if (this.isFloor) {
      this.reader_data = {
        ...this.$store.state.accessPoint.edit_acu_data.readers,
      };

      this.reader_data.name = this.reader_type[this.reader_data.type];
    } else {

      if (Number.isInteger(+this.active_point)) {
        access_point = this.access_points.find(
          (a) => a.id == +this.active_point
        );
        if (Number.isInteger(+this.active_reader)) {
          reader = {
            ...access_point.readers.find((r) => r.id == +this.active_reader),
          };
        } else {

          reader = { ...access_point.new_readers[this.active_reader] };
        }
      } else {
        access_point =
          this.$store.state.accessPoint.edit_acu_data.new_access_points[
          this.active_point
          ];

        reader = { ...access_point.readers[this.active_reader] };
      }

      if (!reader.data) {
        this.reader_data = { ...reader, name: this.reader_type[reader.type] };
      } else if (reader.reader_info) {
        this.reader_data = {
          ...reader.reader_info,
          name: reader.reader_info.data.device,
        };
      } else if (reader.data && !reader.reader_info) {
        this.reader_data = {
          ...reader,
          name: reader.data.device,
        };
      }
    }

  },
  mounted() {
    const extDevice = this.$store.state.accessPoint.ext_devicesList
    const ext_dev = [...this.componentSourcesList];
    for (let item of extDevice) {
      if (this.expansion_boards.reader_board[item.ext_board]) {
        if (this.expansion_boards.reader_board[item.ext_board].readers > 0) {
          ext_dev.push({
            ...item, id: item.id, label: item.label,
            disabled: item.label === "GENERIC" ? this.isGENERICSelected : false
          })
        }
      }
    }
    this.componentSourcesList = ext_dev;

    const componentSourceType = this.componentSourcesList.find(item => {
      return item.id === this.reader_data.component_source
    });

    if (componentSourceType) {
      if (componentSourceType.ext_board === "AIR-R") {
        this.port_items = [
          { id: 1, label: "Internal" },
          { id: 2, label: "External" },
        ]
      } else if (componentSourceType.ext_board === "GENERIC") {
        this.port_items = [
          { id: 1, label: "Internal" },
        ]
      } else {
        this.port_items = [
          { id: 1, label: "Wiegant port 1" },
          { id: 2, label: "Wiegant port 2" },
        ]
      }
    } else if (this.editACUModel === "AIR-CR") {
      this.port_items = [
        { id: 1, label: "Internal" },
        { id: 2, label: "External" },
      ]
    }
    if (componentSourceType) {
      if (componentSourceType.ext_board === "GENERIC" || componentSourceType.label === "ACU") {

        if (this.reader_data.type == 1) {
          this.isDisabledInterfaceType = false;
        } else {
          this.isDisabledInterfaceType = true;
          this.reader_data.wg_type = 0;
        }
      } else if (componentSourceType.ext_board === "AIR-R") {
        this.isDisabledInterfaceType = true;
        this.reader_data.wg_type = 0;
        this.isDisabledReaderType = true;
        this.reader_data.type = 0;
      }
    }


    this.port_items = [...this.definedPortOptionList(this.port_items, this.reader_data.component_source)]
    this.ports = this.port_items;
    this.directionItem = this.reader_data.direction;
    this.portItem = this.reader_data.port;
    this.setPorts();
    this.setDirectionPorts();


  },
  components: {
    vSelect,
    Treeselect,
  },
};
</script>

<style lang="scss">
@import url("../../../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.css");
</style>
